import { render, staticRenderFns } from "./form-aus.vue?vue&type=template&id=580ca992&scoped=true&"
import script from "./form-aus.vue?vue&type=script&lang=js&"
export * from "./form-aus.vue?vue&type=script&lang=js&"
import style0 from "./form-aus.vue?vue&type=style&index=0&id=580ca992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580ca992",
  null
  
)

export default component.exports